/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchScansResultsEquipmentModel } from './search-scans-results-equipment-model';
import { SearchScanResultOutcome } from './search-scan-result-outcome';
import { ScanResultReferenceSpec } from './scan-result-reference-spec';
import { SearchScanResultDevice } from './search-scan-result-device';


export interface SearchScanResultsResponse { 
    id: string;
    scanId: string;
    containerId?: string | null;
    containerName: string;
    ipAddress: string;
    scanResultId?: string | null;
    equipmentId?: string | null;
    macAddress?: string | null;
    model?: SearchScansResultsEquipmentModel;
    referenceSpec?: ScanResultReferenceSpec;
    rawModel?: string | null;
    firmware?: string | null;
    result?: SearchScanResultOutcome;
    previousDevice?: SearchScanResultDevice;
    isFinalized?: boolean;
    detectedAtUtc?: string | null;
    finalizedAtUtc?: string | null;
}

